
<ion-content>
  <ion-card class="cookiemodal">
    <ion-card-header class="head">
      <div id="h1">{{title}}</div>
    </ion-card-header>
    <ion-card-content class="cont">
      <div id="p1">{{text}}<a href="/privacy">{{privacy}}</a>{{text2}}</div>
    </ion-card-content>
    <ion-grid class="foot">
      <ion-row>
        <ion-col id="col1">
          <ion-button id="b1" (click)="dismiss(1)">{{ accept }}</ion-button>
        </ion-col>
        <ion-col id="col2">
          <ion-button id="b2" (click)="dismiss(0)">{{ decline }}</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
</ion-content>